module.exports = __webpack_public_path__ + "static/media/Logout.bfa72313.svg";